import { Button, CircularProgress } from "@mui/material"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogTitle from "@mui/material/DialogTitle"
import { ProgressWrapper } from "components/common-styles"
import PaperComponent from "components/common/paper-component"

const AlertDialog = ({ isProgress, content, open, onClose, onOK }) => {
  const handleClose = (event, reason) => {
    if (reason && reason === "backdropClick") return

    onClose()
  }

  return (
    <Dialog open={open} onClose={handleClose} PaperComponent={PaperComponent} aria-labelledby="draggable-dialog-title">
      <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
        {!isProgress ? "Information" : "Saving..."}
      </DialogTitle>
      <DialogContent dividers style={{ display: "flex", justifyContent: "center", alignItems: "center", minWidth: 400, minHeight: 100 }}>
        {isProgress ? (
          <ProgressWrapper>
            <CircularProgress size={64} />
          </ProgressWrapper>
        ) : (
          <div dangerouslySetInnerHTML={{ __html: content }}></div>
        )}
      </DialogContent>
      {!isProgress && (
        <DialogActions>
          <Button id="btnAlertOK" onClick={() => (onOK ? onOK() : onClose())} variant="contained">
            OK
          </Button>
        </DialogActions>
      )}
    </Dialog>
  )
}

export default AlertDialog
